import CurrentLocation from './CurrentLocation'

export default CurrentLocation